var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { LazyLinkSignatureRepository } from '../repositories/lazy-link-signature-repository.interface';
let LazyLinkSignatureServiceImpl = class LazyLinkSignatureServiceImpl {
    constructor(_lazyLinkSignatureRepository) {
        this._lazyLinkSignatureRepository = _lazyLinkSignatureRepository;
    }
    getPatentSignatureData(patentIds, folderId) {
        return this._lazyLinkSignatureRepository.getPatentSignatureData(patentIds, folderId);
    }
};
LazyLinkSignatureServiceImpl = __decorate([
    injectable(),
    __param(0, inject(LazyLinkSignatureRepository)),
    __metadata("design:paramtypes", [typeof (_a = typeof LazyLinkSignatureRepository !== "undefined" && LazyLinkSignatureRepository) === "function" ? _a : Object])
], LazyLinkSignatureServiceImpl);
export { LazyLinkSignatureServiceImpl };
